
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gfgCUh5UPU_45X5RL__Okrz6TrMoDtS2MQYs_AVlNl_45DvEMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexO9eX1gvK_45Hidp8HebKnv3A6T7LXwZDVJd_450kLO8fxYwMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchNdxoLtG2nztBNlT2eyYNH8PLhyEmwfnFJ7_1LbZTjYoMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index_45jM2YaHSn74Vh6nkufU2mxI821w_0iXfMEBY5tAgwX4Meta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93F9kvqvDqMYkkho7ntzZTq29z4ePyKTL8i4lC1OCdUecMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexqy9LCuDZrO6__45AOkga2NhFXh7XCG6RKHxhL7OViYTOMMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_934Xo7vwxAyDnQve0dIuXynSxzM9LxP4b6DUgs_8uMYR4Meta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexF_TRqrydQPuAcjKQj55LfFnn6PhpqXcxftKwjCsZMgMMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93z987_8wS9jsvmeCQtTiwAUFmqV_453oHSkZhXxUwqTtcgMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_45K_RqKC4xfl0Vk57r3k8RinS_45aRXRQHZylblD0_45JFWMMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2s4A91EXfrXeX4oEuWcEb3oBB0hDumDO3uxR_IRNGwAMeta } from "/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexqy9LCuDZrO6__45AOkga2NhFXh7XCG6RKHxhL7OViYTOMMeta || {},
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexF_TRqrydQPuAcjKQj55LfFnn6PhpqXcxftKwjCsZMgMMeta || {},
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_45K_RqKC4xfl0Vk57r3k8RinS_45aRXRQHZylblD0_45JFWMMeta || {},
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2s4A91EXfrXeX4oEuWcEb3oBB0hDumDO3uxR_IRNGwAMeta || {},
    component: () => import("/codebuild/output/src3173137637/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]